import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ObjectExplorerComponent } from './object-explorer.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import {MatTabsModule} from '@angular/material/tabs';
import {MatDialogModule} from '@angular/material/dialog';
import { ListPanelModule } from 'src/app/bloom/specialized-panels/list-panel/list-panel.module';
import { CollectFnOptions } from './collect-fn-options/collect-fn-options.component';
import { ParameterInputsModule } from '../parameter-inputs/parameter-inputs.module';
import { ConnectionInfoHeaderComponent } from '../connection-info-header/connection-info-header.component';
import { ListPublishingDialogModule } from '../list-publishing-dialog/list-publishing-dialog.module';
import { MatChipsModule } from '@angular/material/chips';
import { SpinnerModule } from '../spinner/spinner.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterModule } from '@angular/router';
import { FormPublishingDialogModule } from '../form-publishing-dialog/form-publishing-dialog.module';

@NgModule({
  declarations: [ObjectExplorerComponent, CollectFnOptions],
  imports: [
    RouterModule,
    CommonModule,
    MatPaginatorModule,
    MatCardModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    FlexLayoutModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatTabsModule,
    ListPanelModule,
    MatDialogModule,
    ParameterInputsModule,
    ConnectionInfoHeaderComponent,
    ListPublishingDialogModule,
    MatChipsModule,
    SpinnerModule,
    MatExpansionModule,
    FormPublishingDialogModule
  ],
  exports: [ObjectExplorerComponent]
})

export class ObjectExplorerModule { }
